import { requireOptionalNativeModule } from 'expo-modules-core';

export default requireOptionalNativeModule('ExpoFontUtils');
